import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, HandHeart } from "lucide-react";
import { LOGO_URL, scrollToId } from "@/lib/site";

const LINKS = [
  { id: "program", label: "Program" },
  { id: "cara-donasi", label: "Cara Donasi" },
  { id: "transparansi", label: "Transparansi" },
  { id: "faq", label: "FAQ" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToId(id), 60);
  };
  return (
    <header data-testid="navbar" className="fixed top-0 inset-x-0 z-50 bg-cream/85 backdrop-blur-md border-b-2 border-ink/10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 sm:h-[72px] flex items-center justify-between gap-4">
        <button data-testid="nav-logo-badge" onClick={() => go("beranda")} className="flex items-center gap-3 text-left">
          <img
            src={LOGO_URL}
            alt="Logo Public Relations 2025"
            className="w-10 h-10 sm:w-11 sm:h-11 rounded-full border-2 border-ink shadow-retro-sm object-cover"
          />
          <span className="leading-none">
            <span className="block font-display font-black text-base sm:text-lg tracking-tight">BANTU DONASI</span>
            <span className="block text-[10px] sm:text-[11px] font-bold tracking-[0.25em] text-gold-dark uppercase mt-1">
              Bersama PR ✦ 2025
            </span>
          </span>
        </button>
        <nav className="hidden md:flex items-center gap-7">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-semibold text-pine hover:text-ink transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-donate-cta"
            onClick={() => go("donasi")}
            className="btn-retro bg-gold text-ink rounded-full px-5 py-2.5 text-sm"
          >
            <HandHeart className="w-4 h-4" /> Donasi Sekarang
          </button>
        </nav>
        <button data-testid="nav-menu-toggle" className="md:hidden p-2" onClick={() => setOpen(!open)} aria-label="Buka menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="md:hidden overflow-hidden border-t-2 border-ink/10 bg-cream"
          >
            <div className="px-5 py-4 flex flex-col gap-3">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-mobile-link-${l.id}`}
                  onClick={() => go(l.id)}
                  className="text-left font-semibold py-1"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="nav-mobile-donate-cta"
                onClick={() => go("donasi")}
                className="btn-retro bg-gold text-ink rounded-full px-5 py-3 text-sm w-fit"
              >
                <HandHeart className="w-4 h-4" /> Donasi Sekarang
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
